import type { Treaty } from '@elysiajs/eden';
import type { MarketFeedClientT } from '@web/api/marketFeedClient';

export type TradeWorkbenchIntervalT = '1m' | '5m' | '15m' | '1h' | '4h' | '1d';
export type TradeWorkbenchDenominationT = 'native' | 'usdc';
export type TradeWorkbenchSidebarTabT = 'order-book' | 'trades';
export type TradeWorkbenchTimezoneT =
  | 'local'
  | 'UTC'
  | 'America/Los_Angeles'
  | 'America/New_York'
  | 'Europe/London'
  | 'Asia/Singapore';

type MarketsResponseT = Treaty.Data<MarketFeedClientT['markets']['get']>;
type MarketRouteT = ReturnType<MarketFeedClientT['markets']>;

export type MarketDefinitionT = MarketsResponseT['markets'][number];
export type MarketSummaryT = Treaty.Data<MarketRouteT['summary']['get']>;

const TRADE_WORKBENCH_INTERVALS: readonly TradeWorkbenchIntervalT[] = [
  '1m',
  '5m',
  '15m',
  '1h',
  '4h',
  '1d',
];
const TRADE_WORKBENCH_DENOMINATIONS: readonly TradeWorkbenchDenominationT[] = [
  'native',
  'usdc',
];
const TRADE_WORKBENCH_SIDEBAR_TABS: readonly TradeWorkbenchSidebarTabT[] = [
  'order-book',
  'trades',
];
const TRADE_WORKBENCH_TIMEZONES: readonly TradeWorkbenchTimezoneT[] = [
  'local',
  'UTC',
  'America/Los_Angeles',
  'America/New_York',
  'Europe/London',
  'Asia/Singapore',
];

export function isTradeWorkbenchInterval(
  value: unknown,
): value is TradeWorkbenchIntervalT {
  return isStringInList({
    list: TRADE_WORKBENCH_INTERVALS,
    value,
  });
}

export function isTradeWorkbenchDenomination(
  value: unknown,
): value is TradeWorkbenchDenominationT {
  return isStringInList({
    list: TRADE_WORKBENCH_DENOMINATIONS,
    value,
  });
}

export function isTradeWorkbenchSidebarTab(
  value: unknown,
): value is TradeWorkbenchSidebarTabT {
  return isStringInList({
    list: TRADE_WORKBENCH_SIDEBAR_TABS,
    value,
  });
}

export function isTradeWorkbenchTimezone(
  value: unknown,
): value is TradeWorkbenchTimezoneT {
  return isStringInList({
    list: TRADE_WORKBENCH_TIMEZONES,
    value,
  });
}

function isStringInList<T extends string>(input: {
  list: readonly T[];
  value: unknown;
}): boolean {
  if (typeof input.value !== 'string') {
    return false;
  }

  for (const allowedValue of input.list) {
    if (allowedValue === input.value) {
      return true;
    }
  }

  return false;
}
